// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3W6F5","inputDescription":"styles_inputDescription__1jbv7"};